import { _ } from "../../../core/polyglot/polyglot.js";
import { select } from "../../../core/elements/index.js";
import CsvExporter from "./CsvExporter.js";
import ExcelExporter from "./ExcelExporter.js";
import PdfExporter from "./PdfExporter.js";
import regionWidget from "../../../core/widgets/regionWidget.js";

/**
 * Returns a renderer of a dropdown to pick an exporter, subclass of {@link AbstractReportExporter},
 * such as {@link PdfExporter}. When picked, this widget delegates the
 * export of a {@link Report} to the picked exporter.
 *
 * @param {Report} report -
 * @param {Company} company -
 * @param {object} reportDisclaimerTemplateVariables - various variables to
 *   build the report disclaimer. It can be obtained using {@link ReportDisclaimer#buildTemplateVariables}
 * @param {function} selectedDimensionsLabel - callback to provides
 *   information about the selected dimensions. This is invoked without
 *   any parameter and should return a translated label, reflecting the
 *   selected dimension, if any. It can return undefined if no dimension has
 *   been selected.
 * @param {AbstractReportExporter[]} [exporters] - List of specific
 *   exporters if nor all exporters are required
 */
export default function makeReportExporterPicker({
	report,
	company,
	reportDisclaimerTemplateVariables,
	selectedDimensionsLabel,
	exporters = [new ExcelExporter(), new PdfExporter(), new CsvExporter()],
}) {
	const downloadSpecs = {
		report,
		exportingSpec: {
			company,
			reportDisclaimerTemplateVariables,
			selectedDimensionsLabel,
		},
	};

	const items = exporters.map((exporter) => ({
		value: exporter,
		label: exporter.simpleLabel(),
	}));

	const exportSelect = regionWidget({
		content: (html) => {
			html.render(
				select({
					items,
					allowEmptySelection: true,
					emptyLabel: _("Save as..."),
					name: "export-type-picker",
					onChange: (exporter) => {
						if (!exporter) {
							return;
						}

						exporter.download(downloadSpecs);
						exportSelect.update();
					},
				}),
			);
		},
	});

	return (html) => html.span({ "data-help": "export-button" }, exportSelect);
}
